import React from 'react';
import { ArrowRightIcon, CheckIcon, MapPinIcon, SparklesIcon } from 'lucide-react';
import { activeAlert, resolvedAlert } from '../../data/avis';
export function ImportantForYou() {
  return <section aria-labelledby="important-titre" className="mt-10" data-id="element-367" data-mp="2t2bk60ha45ez">
      <h2 id="important-titre" className="text-2xl font-extrabold tracking-tight text-ville-navy" data-id="element-368" data-mp="2t0gygjy6o99u">
        Important pour vous
      </h2>

      <article className="mt-4 overflow-hidden rounded-3xl border border-slate-200 bg-white" data-id="element-369" data-mp="3kuanx90nwci6">
        <div className="border-l-4 border-red-600 p-6 sm:p-7" data-id="element-370" data-mp="3grw7evkgtou2">
          <div className="flex flex-wrap items-center gap-3" data-id="element-371" data-mp="3gql1ap3js4zs">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-red-600 px-3 py-1 text-xs font-bold uppercase tracking-wider text-white" data-id="element-372" data-mp="3bs1d0i1heh49">
              Urgent
            </span>
            <span className="text-sm text-slate-500" data-id="element-373" data-mp="20f7edtad3n25">{activeAlert.since}</span>
          </div>

          <h3 className="mt-3 text-xl font-extrabold leading-tight text-ville-navy sm:text-2xl" data-id="element-374" data-mp="1ve1ffdq3z3k6">
            {activeAlert.title}
          </h3>
          <p className="mt-2 max-w-2xl text-[15px] leading-relaxed text-slate-600" data-id="element-375" data-mp="2f9zyx5cmz0xp">{activeAlert.summary}</p>

          <p className="mt-4 inline-flex flex-wrap items-center gap-2 rounded-full bg-slate-50 px-4 py-2 text-sm" data-id="element-376" data-mp="2jbczp10vgdxr">
            <MapPinIcon className="h-4 w-4 text-red-600" aria-hidden="true" data-id="element-377" data-mp="2acrc2rgjm8q4" />
            <span className="font-bold text-ville-navy" data-id="element-378" data-mp="2aeude7n5boa5">{activeAlert.address}</span>
            <span className="text-slate-500" data-id="element-379" data-mp="1vm0jhh74n5ly">· {activeAlert.addressLabel}</span>
          </p>

          <div className="mt-6 grid gap-4 sm:grid-cols-2" data-id="element-380" data-mp="20g4tk9bovtr9">
            <div className="rounded-2xl bg-slate-50 p-4" data-id="element-381" data-mp="1mo85cgd56405">
              <p className="text-xs font-bold uppercase tracking-wider text-slate-500" data-id="element-382" data-mp="1mllx0eiffkgv">Ce qui vous concerne</p>
              <p className="mt-1.5 text-sm leading-relaxed text-ville-navy" data-id="element-383" data-mp="1cp977rq05qre">{activeAlert.concerns}</p>
            </div>
            <div className="rounded-2xl bg-slate-50 p-4" data-id="element-384" data-mp="1hovkg15tz707">
              <p className="text-xs font-bold uppercase tracking-wider text-slate-500" data-id="element-385" data-mp="1hqgfdrw24ryl">À faire</p>
              <p className="mt-1.5 text-sm leading-relaxed text-ville-navy" data-id="element-386" data-mp="yltodjacqmys">{activeAlert.todo}</p>
            </div>
          </div>

          <div className="mt-6 flex flex-wrap items-center gap-3" data-id="element-387" data-mp="otnuu54gbxhh">
            <a href="#avis-officiel" className="inline-flex items-center gap-2 rounded-full bg-ville-navy px-5 py-2.5 text-sm font-bold text-white transition-transform duration-150 ease-ville hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo focus-visible:ring-offset-2" data-id="element-388" data-mp="ort7yl9mdvar">
              Voir les consignes
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-389" data-mp="17mi2edzqwnbo" />
            </a>
            <a href="#avis-officiel" className="text-sm font-bold text-ville-navy underline underline-offset-4 hover:text-ville-indigo" data-id="element-390" data-mp="12kssj1o9efp6">
              Voir l’avis officiel
            </a>
          </div>

          <div className="mt-6 rounded-2xl border border-slate-200 p-4" data-id="element-391" data-mp="22tsh77a4vmbx">
            <p className="flex items-center gap-2 text-sm font-bold text-ville-indigo" data-id="element-392" data-mp="22rfrg7y4w7ob">
              <SparklesIcon className="h-4 w-4" aria-hidden="true" data-id="element-393" data-mp="27svda284yi7r" />
              Demander à ATNA
            </p>
            <ul className="mt-3 flex flex-wrap gap-2" data-id="element-394" data-mp="2cpvenzu1iwsj">
              {activeAlert.questions.map(question => <li key={question} data-id="element-395" data-mp="2mhrrkh0scrgt">
                  <button type="button" className="rounded-full bg-slate-50 px-3.5 py-1.5 text-sm text-slate-600 transition-colors duration-150 ease-ville hover:bg-ville-indigo-soft hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-396" data-mp="2mggetrpd49dk">
                    {question}
                  </button>
                </li>)}
            </ul>
          </div>
        </div>
      </article>

      <article className="mt-3 flex flex-wrap items-center gap-4 rounded-2xl border border-slate-200 bg-white px-5 py-4" data-id="element-397" data-mp="164b1s0lcmlx1">
        <span className="grid h-10 w-10 shrink-0 place-items-center rounded-full bg-ville-indigo-soft text-ville-indigo" aria-hidden="true" data-id="element-398" data-mp="2wisfy06oxqvz">
          <CheckIcon className="h-5 w-5" data-id="element-399" data-mp="35l1rmtdp3qay" />
        </span>
        <div className="min-w-0 flex-1" data-id="element-400" data-mp="35ki7r74hirua">
          <h3 className="font-bold text-ville-navy" data-id="element-401" data-mp="31jpvs648a8ub">{resolvedAlert.title}</h3>
          <p className="text-sm text-slate-600" data-id="element-402" data-mp="31hc66csbhou5">{resolvedAlert.detail}</p>
        </div>
        <button type="button" className="text-sm font-semibold text-slate-500 underline underline-offset-4 transition-colors duration-150 ease-ville hover:text-ville-navy focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-403" data-mp="2du3xdkvojxnd">
          Supprimer
        </button>
      </article>
    </section>;
}